import { Box } from "@mui/material"

export const NoDataFound = () => {
    return <>
        <Box sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
        }}>
            <img src="/assets/images/no_data.jpeg" alt=""/>
            <p style={{
                fontSize: '16px',
                color: '#a3a4a4',
                marginTop: '-10px',
                marginBottom: '10px',
            }}>No Data Found!</p>
        </Box>
    </>
}